import {
  containerCss,
  marginCss,
  mobileMarginCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import {
  SearchItemInterface,
  SearchItemTextInterface,
} from 'src/shared/types/entities/search-interface'
import styled, { css } from 'styled-components'

export const SearchItemUi = styled.div<SearchItemInterface>`
  display: flex;
  gap: 12px;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #F8FAFC;
  }

  ${containerCss};
`
export const SearchItemContainerUi = styled.div`
  width: 100%;
`

interface SearchItemImageWrapperUiStylesInterface {
  imagePath: string
}

export const SearchItemImageContainerUi = styled.div<SearchItemImageWrapperUiStylesInterface>`
  width: 36px;
  height: 36px;
  max-height: 36px;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 50%;
  background-image: ${p => (p.imagePath ? `url(${p.imagePath})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f2f4f7;
`

export const SearchItemTitleUi = styled.h3<SearchItemTextInterface>`
  ${textCss};
  ${marginCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobileTextCss}
    ${mobileMarginCss}
  `}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`
export const SearchItemTextUi = styled.p<SearchItemTextInterface>`
  ${textCss};
  ${marginCss};

  mark {
    color: inherit;
    font-weight: 700;
    background-color: transparent;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobileTextCss}
    ${mobileMarginCss}
  `}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`
